import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["color", "loop", "action", "size", "source", "segments", "onComplete"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Animation/Animation.js",
    _this = this;

import React, { useState, useEffect, useMemo } from 'react';
import { Transition } from 'react-transition-group';
import Fade from './fade';
import Lottie from '../../core/components/Lottie';
import { testIdProps } from '../../helpers';
import { Wrapper } from './style';
var DEFAULT_SIZE = '40px';
var Action = {
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop'
};

var coloredSource = function coloredSource(source, color) {
  var r = /^#?(..)(..)(..)(..)?$/.exec(color);
  var arrColor = [r[1], r[2], r[3], r[4] || 'FF'].map(function (c) {
    return parseInt(c, 16) / 255;
  });
  return JSON.parse(JSON.stringify(source).replace(/"k":\[[0.\d]+,[0.\d]+,[0.\d]+,1\]/g, "\"k\":[".concat(arrColor, "]")));
};

var Animation = function Animation(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fadeIn = _useState2[0],
      setFadeIn = _useState2[1];

  var color = props.color,
      loop = props.loop,
      action = props.action,
      size = props.size,
      source = props.source,
      segments = props.segments,
      onComplete = props.onComplete,
      rest = _objectWithoutProperties(props, _excluded);

  useEffect(function () {
    setFadeIn(action !== Action.STOP);
  }, [action]);
  var animationData = useMemo(function () {
    return color ? coloredSource(source, color) : source;
  }, [color, source]);
  useEffect(function () {
    // Reset fade transition if animation source change
    setFadeIn(false);
    setTimeout(function () {
      return setFadeIn(true);
    }, 0);
  }, [source]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    size: size || DEFAULT_SIZE
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Transition, {
    "in": fadeIn,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: 200,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Fade, {
      state: state,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Lottie, {
      "data-testid": "lottieId",
      animationData: animationData,
      config: {
        loop: loop
      },
      play: action !== Action.STOP,
      pause: action === Action.PAUSE,
      segments: segments,
      height: size || DEFAULT_SIZE,
      width: size || DEFAULT_SIZE,
      onComplete: onComplete,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 13
      }
    }));
  }));
};

Animation.defaultProps = {
  action: Action.PLAY,
  loop: true
};
export default Animation;